module.exports = __webpack_public_path__ + "img/Penny-Tote-02.337940f4.jpg";